export enum OrderDeliveryStatus {
    IN_PROGRESS = 1,
    SENT = 2,
    NOT_SENT = 3,
    MANUAL_SENT = 4,
    ACCEPTED = 5,
    REJECTED = 6,
    PROCESSESING_ORDER = 7
}
